import { ConditionNodeModel } from "./ConditionNodeModel";
import { EventNodeModel } from "./EventNodeModel";
import { FunctionNodeModel } from "./FunctionNodeModel";
import { TerminateNodeModel } from "./TerminateNodeModel";
import { TriggerNodeModel } from "./TriggerNodeModel";
import { VariableNodeModel } from "./VariableNodeModel";

const nodes = {
  VariableNode: VariableNodeModel,
  TriggerNode: TriggerNodeModel,
  ConditionNode: ConditionNodeModel,
  TerminateNode: TerminateNodeModel,
  FunctionNode: FunctionNodeModel,
  EventNode: EventNodeModel,
};

export const AdaptiveNode = (type) => {
  const NodeClass = nodes[type];
  if (!NodeClass) {
    console.error(`Node type "${type}" not found`);
    return null;
  }
  return NodeClass;
};
